<template>
    <multiselect class="multiselect-primary"
                 v-model="model"
                 :value="test"
                 @input="inputDefault"
                 :options="options"
                 width="100%"
                 :required="required"
                 :disabled="disabled"
                 :label="text"
                 :multiple="true"
                 :close-on-select="false"
                 :clear-on-select="false"
                 :track-by="trackBy"
                 :placeholder="placeholder"
                 :selectLabel="selectLabel"
                 :selectedLabel="selectedLabel"
                 :deselectLabel="deselectLabel"
                 :noResult="noResult"
                 :showNoResults="showNoResults">
        <span slot="noOptions">{{noResult}}</span>
    </multiselect>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array, default: () => []
            },
            input: { type: Function, default: null },
            options: { type: Array, default: [] },
            required: { type: Boolean, default: false },
            disabled: { type: Boolean, default: false },
            text: { default: 'text' },
            trackBy: { default: 'value' },
            placeholder: { default: 'Todos' },
            selectLabel: { default: '' },
            selectedLabel: { default: '' },
            deselectLabel: { default: '' },
            noResult: { default: 'Sem Resultados' },
            showNoResults: { type: Boolean, default: true },
        },
        data() {
            return {
                model: this.value ? this.value : []
            }
        },
        computed: {
            test: function () {
                if (this.value && this.value.length) {
                    this.model = this.options.filter(x => this.value.find(p => p.toString() === x[this.trackBy].toString()))
                }
            }
        },
        methods: {
            inputDefault: function (val) {
                this.$emit('input', val.map(p => p[this.trackBy]))

                if (this.input)
                    this.input(val)
            }
        },
        watch: {
            model: function (newValue, oldValue) {
                //if (newValue) {
                //    if (newValue.length > 0)
                //        this.$el.querySelectorAll(".multiselect .multiselect__tags input").forEach(p => p.setAttribute("value", newValue.map(p => p[this.trackBy])))
                //    else
                //        this.$el.querySelectorAll(".multiselect .multiselect__tags input").forEach(p => p.value = [])
                //}
            }
        },
        directives: {
            'select-overflow': {
                inserted: (el, _binding, vnode) => {

                    vnode.child.$watch('isOpen', isOpen => {
                        var element = el.getElementsByClassName("multiselect__content-wrapper")[0]
                        element.style.position = 'fixed'
                        element.style.width = el.offsetWidth + "px"
                    })
                }
            }
        }
    }
</script>